/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View } from '@components/atoms'
import { Footer } from '@components/systems'
import Markdown from 'markdown-to-jsx'

import { policyDocStyle } from './policyDoc.style'

/**
 * Privacy Policy — Monolith(2안). 구 페이지는 `pages/home/PrivacyPolicy.page.tsx` 에 보관.
 *
 * 문서(`policies/privacyPolicy_en.md`)는 한 글자도 건드리지 않았다. 바뀐 것은 타이포뿐이다.
 * 구 페이지의 useEffect 에는 의존성 배열이 없어서 렌더마다 md 를 다시 import·fetch 했고,
 * setState 가 다시 렌더를 불러 무한 루프였다 — 여기서는 마운트 한 번만 읽는다.
 */
const MonolithPrivacyPolicyPage = () => {
	// state
	const [markdown, setMarkdown] = React.useState<string>('')

	React.useEffect(() => {
		let isAlive = true

		import('../policies/privacyPolicy_en.md')
			.then(res => fetch(res.default))
			.then(res => res.text())
			.then(text => {
				if (isAlive) setMarkdown(text)
			})
			.catch(() => {
				if (isAlive) setMarkdown('')
			})

		return () => {
			isAlive = false
		}
	}, [])

	return (
		<View css={style}>
			<View className="mnWrap">
				<View className="mnDoc">
					{markdown === '' ? (
						<span className="mnDocQuiet">Loading</span>
					) : (
						<Markdown>{markdown}</Markdown>
					)}
				</View>
			</View>

			<Footer />
		</View>
	)
}

export default MonolithPrivacyPolicyPage

const style = css({
	...policyDocStyle,
})
